export default __webpack_public_path__ + "static/media/guv-3.b5c74ce8.png";